import templateUrl from 'emun.auth/register-retailer.htm'
import controller from 'emun.auth/register-retailer.controller'

export default {
    templateUrl,
	bindings: {
		retailer: '<',
        retailerId: '@',
        tin: '@',
        language: '@',
        guestMode: '<',
        formioId: "@"
        //cancelUrl: '@',
        //colSplit: '@',
        //termsAndConditionsUrl: '@',
    },
    controller,
};